module.exports = __webpack_public_path__ + "static/img/zijianMobel1.97453321.png";